import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import {
  Avatar,
  Badge,
  Box,
  ButtonBase,
  Checkbox,
  Chip,
  Collapse,
  Divider,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  styled,
  SvgIcon,
  Typography
} from '@mui/material';
import Star01Icon from '@untitled-ui/icons-react/build/esm/Star01';
import TrashIcon from '@untitled-ui/icons-react/build/esm/Trash03';
import { find, get, includes, map, size } from 'lodash';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LicensePlate from 'src/components/license-plate';
import { selectIsOwnedSelected, toggleOwnedSelected, unSelectOwned } from '../../slices/booking-slice';
import CircleColor from 'src/components/circle-color';
import LicensePlateColor from 'src/components/license-plate-color';

export const RatingStar = ({ showStar = false, sx = {} }) => {
  // if (!showStar) {
  //   return (
  //     <Stack>
  //       <Typography color="text.secondary" noWrap variant="caption">
  //         5 /20
  //       </Typography>
  //     </Stack>
  //   );
  // }

  return (
    <Stack alignItems="center" spacing={1} direction="row" sx={sx}>
      {showStar && (
        <SvgIcon color="action">
          <Star01Icon />
        </SvgIcon>
      )}

      <Typography color="text.secondary" noWrap variant="caption">
        5 /20
      </Typography>
    </Stack>
  );
};

export const ResultOwnedCarAssign = ({ displayName, car }) => {
  return (
    <Stack mt={1}>
      {/* <Stack direction="row" alignItems="flex-start" justifyContent="space-between" onClick={() => handleToggle(ownedId, selected)}> */}
      <Stack direction="row" alignItems="center" columnGap={1} px={2} textAlign="left" width="100%">
        <Avatar
          sx={{
            backgroundColor: 'primary.alpha12'
          }}
        >
          <SvgIcon
            sx={{
              color: 'primary.main'
            }}
          >
            <EmojiTransportationIcon />
          </SvgIcon>
        </Avatar>

        {/* <Stack direction="row" alignItems="center" columnGap={1}> */}
        <Typography>{displayName}</Typography>
      </Stack>

      <Box ml={5}>
        <ResultCar car={car} />
      </Box>
    </Stack>
  );
};

export const DisplayOwned = ({ displayName, ...props }) => {
  return (
    <Stack justifyContent="flex-start" alignItems="center" width="100%" px={2} columnGap={1} rowGap={1} {...props}>
      <Avatar
        sx={{
          backgroundColor: 'primary.alpha12'
        }}
      >
        <SvgIcon
          sx={{
            color: 'primary.main'
          }}
        >
          <EmojiTransportationIcon />
        </SvgIcon>
      </Avatar>

      {/* <Stack direction="row" alignItems="center" columnGap={1}> */}
      <Typography noWrap>{displayName}</Typography>
      {/* </Stack> */}
      {/* <RatingStar sx={{ ml: 'auto' }} showStar={true} /> */}
    </Stack>
  );
};

export const ResultOwned = ({ result }) => {
  const [currentId, setCurrentId] = useState();
  const dispatch = useDispatch();

  const ownedId = result.id;
  const selected = currentId ? currentId === ownedId : false;

  const ownedSelected = useSelector((state) => selectIsOwnedSelected(state, ownedId));

  const handleToggleSelect = useCallback((ownedId) => {
    dispatch(toggleOwnedSelected(ownedId));
  }, []);
  const handleSelect = useCallback((carId) => {
    setCurrentId(carId);
  }, []);

  const handleDeselect = useCallback(() => {
    setCurrentId(undefined);
  }, []);

  const handleToggle = useCallback(
    (ownedId, selected) => {
      if (!selected) {
        handleSelect(ownedId);
      } else {
        handleDeselect();
      }
    },
    [handleDeselect, handleSelect]
  );

  return (
    <Stack mt={1}>
      {/* <Stack direction="row" alignItems="flex-start" justifyContent="space-between" onClick={() => handleToggle(ownedId, selected)}> */}
      <ButtonBase
        sx={{
          flexDirection: 'row',
          // alignItems: 'flex-start',
          justifyContent: 'flex-start',
          columnGap: 1,
          px: 2,
          textAlign: 'left',
          width: '100%'
        }}
        onClick={() => handleToggle(ownedId, selected)}
      >
        <StyledBadge
          badgeContent={size(result.cars)}
          color="primary"
          size="small"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
        >
          <Avatar
            onClick={(event) => {
              event.stopPropagation();
              handleToggleSelect(ownedId);
            }}
            sx={{
              ...(ownedSelected && { backgroundColor: 'primary.alpha12' })
            }}
          >
            <SvgIcon
              sx={{
                ...(ownedSelected && { color: 'primary.main' })
              }}
            >
              <EmojiTransportationIcon />
            </SvgIcon>
          </Avatar>
        </StyledBadge>
        {/* <Stack direction="row" alignItems="center" columnGap={1}> */}
        <Typography>{result.displayName}</Typography>
        {/* </Stack> */}
        <RatingStar sx={{ ml: 'auto' }} showStar={true} />
      </ButtonBase>

      <Collapse in={selected}>
        <Divider sx={{ mt: 1 }} />
        <Stack rowGap={2} px={2} pt={1}>
          {map(result.cars, (car) => {
            return <ResultCar key={car.id} car={car} />;
          })}
        </Stack>
      </Collapse>
    </Stack>
  );
};

export const ResultOwnedSetBaseFee = ({ result, selectedForNhaxe, onToggleBaseFee, onSetCarsCheck }) => {
  const dispatch = useDispatch();

  const ownedId = result.id;

  const handleUnSelectOwned = useCallback(() => {
    dispatch(unSelectOwned(ownedId));
  }, [ownedId]);

  const handleSetCarsCheck = (event) => {
    const car = find(result.cars, ['id', event.target.value]);
    onSetCarsCheck(ownedId, event.target.value, car.baseFeeId);
  };
  const selectedBaseFeeId = get(selectedForNhaxe, `${ownedId}.baseFeeId`);
  const selectedBaseFees = get(selectedForNhaxe, `${ownedId}.baseFeeIds`);
  const selectedCarId = get(selectedForNhaxe, `${ownedId}.carId`, '');
  return (
    <Stack mt={1}>
      <Stack direction="row" alignItems="center" justifyContent="flex-start" columnGap={1} px={2} textAlign="left" width="100%">
        <Avatar
          sx={{
            backgroundColor: 'primary.alpha12'
          }}
        >
          <SvgIcon
            sx={{
              color: 'primary.main'
            }}
          >
            <EmojiTransportationIcon />
          </SvgIcon>
        </Avatar>

        <Typography variant="subtitle1">{result.displayName}</Typography>

        <IconButton
          aria-label="close"
          onClick={handleUnSelectOwned}
          sx={{
            ml: 'auto',
            color: (theme) => theme.palette.error.light,
            '&:hover': {
              color: (theme) => theme.palette.error.main // Màu khi hover
            }
          }}
        >
          <TrashIcon />
        </IconButton>
      </Stack>

      <Collapse in={true}>
        <Stack rowGap={2} px={2}>
          <RadioGroup value={selectedCarId} onChange={handleSetCarsCheck} name={`radio-${ownedId}-select-car`} size="small">
            {map(result.cars, (car) => {
              const selectedBaseFee = selectedBaseFeeId === car.baseFeeId || includes(selectedBaseFees, car.baseFeeId);
              return (
                <ResultCarSend
                  key={car.id}
                  ownedId={ownedId}
                  car={car}
                  selectedBaseFee={selectedBaseFee}
                  onToggleBaseFee={onToggleBaseFee}
                />
              );
            })}
          </RadioGroup>
        </Stack>
      </Collapse>
    </Stack>
  );
};

export const ResultBaseFee = ({ ownedId, car, onSetBaseFeeUncheck }) => {
  return (
    <Stack direction="row" columnGap={1} alignItems="center" rowGap={0}>
      <Checkbox
        defaultChecked
        size="small"
        sx={{ p: 0 }}
        onChange={(event) => onSetBaseFeeUncheck(ownedId, car.baseFeeId, event.target.checked)}
      />
      <Typography color="text.secondary" variant="caption">
        {car.baseFee.name}
      </Typography>
    </Stack>
  );
};

export const ResultCarSend = ({ ownedId, car, selectedBaseFee, onToggleBaseFee }) => {
  return (
    <Box sx={{ ml: 5 }}>
      <Stack direction="row" columnGap={1} alignItems="center" rowGap={0}>
        {/* <Checkbox defaultChecked size="small" sx={{ p: 0 }} onChange={(event) => onToggleBaseFee(ownedId, car.id, event.target.checked)} /> */}
        {/* <Radio
          // defaultChecked
          // onChange={(event) => onToggleBaseFee(ownedId, car.id, event.target.checked)}
          value={car.id}
          name="radio-buttons"
          inputProps={{ 'aria-label': car.id }}
        /> */}
        <FormControlLabel
          value={car.id}
          control={<Radio />}
          label={car.model.name}
          slotProps={{
            typography: {
              // color: 'text.secondary',
              variant: 'subtitle2'
            }
          }}
        />
      </Stack>

      <Stack direction="row" columnGap={1} alignItems="center" ml={4}>
        {/* <LicensePlate>{car.licensePlate}</LicensePlate> */}
        <LicensePlateColor licensePlate={car.licensePlate} color={car.color} />

        <Chip
          label={car.baseFee.name}
          size="small"
          variant={selectedBaseFee ? 'filled' : 'outlined'}
          color="primary"
          onClick={() => {
            onToggleBaseFee(ownedId, car.baseFeeId, car.id);
          }}
          sx={{ cursor: 'pointer', borderRadius: '5px' }}
        />
        {/* <Typography color="primary.dark" variant="caption">
          ({car.baseFee.name})
        </Typography> */}
        {/* <Typography color="warning.main" variant="caption" fontWeight="bold">
          {car.licensePlate}
        </Typography> */}
      </Stack>

      {/* <Stack direction="row" columnGap={1}>
        <Typography color="text.secondary" variant="caption">
          - Loại phí :
        </Typography>
        <Typography color="primary.dark" variant="caption">
          {car.baseFee.name}
        </Typography>
      </Stack> */}
    </Box>
  );
};

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    background: 'transparent',
    border: `1px solid ${theme.palette.info.main}`,
    color: theme.palette.text.primary
  }
}));

export const ResultCar = ({ car }) => {
  console.log('ResultCar car', car);
  return (
    <div>
      <Typography variant="subtitle2">
        - {car.model.name} {` (${car.inServiceYear})`}
      </Typography>
      <Stack direction="row" columnGap={1} alignItems="center" ml={1.5} mt={0.5}>
        <LicensePlate>{car.licensePlate}</LicensePlate>
        <CircleColor color={car.color} />
        {car?.baseFee?.name && <Chip label={car.baseFee.name} size="small" variant="outlined" color="warning" />}
      </Stack>
    </div>
  );
};
